import $x from '../../js/$x.js'

export default {
    beforeRouteEnter(to, from, next) {
        const { url, path, sid, title } = to.query
        if (path) $x.jumpMenu({ sid, xpath: path, title, winparas: 'notSet' }, from.query)
        else if (url) $x.jumpApp(url, from.query)
        else console.error('Err jump:', to.query)
        next(false)
    },
}
